export default {
    apiUrl: process.env.VUE_APP_API_URL,
    apiKey: process.env.VUE_APP_API_KEY,
    apiGravatarUrl: process.env.VUE_APP_API_GRAVATAR_URL,
    apiAuthentificationUrl: process.env.VUE_APP_API_AUTHENTIFICATION_URL,
    defaultPosterImage: process.env.VUE_APP_DEFAULT_COVER_IMAGE
}
